import { cn } from '@utils'
import { useSessionStore } from '@stores'

interface StepBackButtonProps {
  onBack?: () => void
  canUndo?: boolean
  singleColumnButtons?: boolean
}

const StepBackButton = ({ onBack, canUndo, singleColumnButtons = false }: StepBackButtonProps) => {
  const session = useSessionStore(s => s.session)
  const allowed = canUndo !== undefined ? canUndo : !!session?.can_undo

  if (!onBack || !allowed) {
    return null
  }

  return (
    <div className={cn('flex justify-center mt-1', singleColumnButtons ? 'w-full md:w-1/2 md:mx-auto' : 'w-full')}>
      <button type="button" className="btn-base back-btn" onClick={() => onBack()}>
        <span>Back</span>
      </button>
    </div>
  )
}

export default StepBackButton
